import { render, staticRenderFns } from "./AmountDueByGroupsReportForm.vue?vue&type=template&id=1b2729a3&"
import script from "./AmountDueByGroupsReportForm.vue?vue&type=script&lang=js&"
export * from "./AmountDueByGroupsReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports